import React, { memo } from 'react';

import { StyledFooterCopyright } from './styles';
import { TextLink } from '../../../../components/atoms/text-link';
import { Heading9, variables } from '../../../../theme';
import { bemClassName } from '../../../../utils/bem';

const b = bemClassName('copyright');

const FooterCopyright = () => {
  return (
    <StyledFooterCopyright>
      <div className={b()}>
        <Heading9>
          © {new Date().getFullYear()}{' '}
          <TextLink color={variables.colors.white} to="/">
            Active Shape.
          </TextLink>{' '}
          All Rights Reserved.
        </Heading9>
      </div>
    </StyledFooterCopyright>
  );
};

export default memo(FooterCopyright);
